import { RESET_FORM } from '../actionTypes';
import { createContactModalActions } from '../reducer';

export default () => createContactModalActions[RESET_FORM]();
